import React from 'react';
import { useApp, useAppDispatch } from '@context/app-context';
import { UserProfile } from '@goodfynd/dashboard';
import { ColorSchemeToggle } from '@goodfynd/layout';

import type { HeaderUserProfileProps } from './types';

export const HeaderUserProfile = ({ options = [] }: HeaderUserProfileProps) => {
  const { isLoggedIn, user } = useApp();
  const { logout } = useAppDispatch();

  return (
    <div>
      <UserProfile
        user={user}
        options={[
          // {
          //   label: 'Personal info',
          //   onClick: () => formRef.current?.open(),
          // },
          // {
          //   divider: true,
          // },
          // {
          //   label: 'Communications',
          //   onClick: () => communicationsPreferencesRef.current?.open(),
          // },
          // {
          //   divider: true,
          // },
          { label: <ColorSchemeToggle color="neutral" /> },
          {
            divider: true,
          },
          ...options,
          {
            hide: !isLoggedIn,
            label: 'Logout',
            onClick: () => logout(),
          },
        ]}
      />
    </div>
  );
};
